import { LegalPageShell } from '@/pages/legal/LegalPageShell';

const VERSION = '2026-08-02';

export function TermsPage() {
  return (
    <LegalPageShell title="Termos de Uso" version={VERSION}>
      <p>
        Estes Termos regulam o uso da plataforma Manejai (SaaS de gestão de rebanho). Ao criar conta,
        você declara ter lido e aceito este documento e a Política de Privacidade.
      </p>
      <h2 className="text-lg font-semibold text-manejai-forest">Serviço</h2>
      <p>
        Portal web, app mobile e APIs para cadastro de animais, eventos, movimentações, reprodução,
        vendas e, quando disponível, identificação assistida por software. Funcionalidades podem
        evoluir; identificação por imagem é auxiliar e não substitui decisão zootécnica.
      </p>
      <h2 className="text-lg font-semibold text-manejai-forest">Seus dados</h2>
      <p>
        Os dados da fazenda (animais, eventos, mídias) são de propriedade do cliente. O Manejai
        possui licença limitada para hospedar e processar esses dados apenas para prestar o serviço.
      </p>
      <h2 className="text-lg font-semibold text-manejai-forest">Planos e pagamento</h2>
      <p>
        Trial de 30 dias e planos pagos via Stripe. Cancelamento pelo portal de assinatura. Após
        cancelamento, dados seguem política de retenção descrita na Privacidade.
      </p>
      <h2 className="text-lg font-semibold text-manejai-forest">Uso de mídia para ML (Anexo A)</h2>
      <p>
        Opcional e revogável. Se aceito, autoriza uso de fotos/vídeos capturados na plataforma para
        melhorar algoritmos de detecção e identificação, inclusive com prestadores de tecnologia
        (ex.: Roboflow), sob contratos de confidencialidade. Pode ser alterado em Configurações.
      </p>
      <h2 className="text-lg font-semibold text-manejai-forest">Contato</h2>
      <p>
        Dúvidas: contato@manejai.com.br · privacidade@manejai.com.br
      </p>
      <p className="text-xs text-manejai-bark/55">
        Versão completa para revisão jurídica: repositório docs/legal/termos-de-uso-rascunho.md
      </p>
    </LegalPageShell>
  );
}
